import Axios from "./axios";

const resource = "privacy-policy-sliders";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}